<div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
    <div class="trezo-card-content">
        <span class="block">
            Total Projects
        </span>
        <h5 class="!text-[20px] mt-[3px] !mb-0">
            22.5k+
        </h5>
        <div class="flex items-center justify-center mx-auto text-secondary-500 bg-secondary-100 dark:bg-[#15203c] w-[77px] h-[77px] my-[15px] rounded-full">
            <i class="material-symbols-outlined !text-[32px]">
                auto_stories
            </i>
        </div>
        <div class="flex items-center justify-between text-sm">
            <span class="block">
                This Month
            </span>
            <span class="leading-none text-success-600">
                <i class="material-symbols-outlined !text-[20px]">
                    trending_up
                </i>
            </span>
        </div>
    </div>
</div>